export default {
  saveTemplate: "api/mail-templates/",
  singleTemplate: (id) => `api/mail-templates/${id}`,
  delTemp:(id) => `api/mail-templates/${id}/`,
};
